import React, { useState, useEffect, useRef, useMemo } from 'react';
import "./products.css";
import Carousel from 'react-bootstrap/Carousel';
import 'react-multi-carousel/lib/styles.css';
import Hearth from '../../assets/icons/hearth.svg';
import Loader from '../../components/loader/dotloader'

import ProductsItem from '../../components/productsItem/products-items';
import { useLocation } from "react-router-dom";
import { Skeleton } from 'primereact/skeleton';
import { Dialog } from 'primereact/dialog';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import { useCart } from '../../contexts/CartContext';
import useToastNotification from '../../hooks/useToastNotification';
import ThreeLoader from '../loader/threeDots'
import { useNavigate } from 'react-router-dom';

import DefaultImg from '../../assets/images/defult-img.svg'
// svgs
import Trash from '../../assets/icons/trash.svg';
import HeartBold from '../../assets/icons/heart-bold.svg';
import Filter from '../../assets/icons/filter.svg';
import FilterMobile from '../../assets/icons/mobile-filter.svg';

import { Col, Form } from 'react-bootstrap';

import { GetProductByCategory, getFavoriteList, addBasket, getBasketList, deleteBasket, GetProducts, getDiscountProduct, GetListGroupKala, GetProductsbBySearch, getAddToFavorite, deleteFavorite } from '../../utils/api';
import { Sidebar } from 'primereact/sidebar';
import { Paginator } from 'primereact/paginator';

const Products = ({ categoryId: propCategoryId }) => {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [basketList, setBasketList] = useState({});
  const [favoritList, setFavoritList] = useState({});
  const { addToCart } = useCart();
  const { basketLists } = useCart();
  const [loadingQuantities, setLoadingQuantities] = useState(false);

  const [categoryId, setCategoryId] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(9);
  const [total, setTotal] = useState(0); // Total records for pagination
  const [loading, setLoading] = useState(false);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const location = useLocation();
  const { showError, showSuccess } = useToastNotification();
  const [categoryChecked, setCategoryChecked] = useState([]); // Holds selected category ID
  const [visibleCategory, setVisibleCategory] = useState(false);
  const [visibleFilter, setVisibleFilter] = useState(false);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [show, setShow] = useState(false);
  // داخل کامپوننت:
  const refs = useRef({}); // یک آبجکت برای ذخیره refs به صورت داینامیک
  const ref = useRef(null); // برای container اصلی Overlay
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShow(false); // تابعی که overlay رو می‌بنده
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show]);
  const getRef = (id) => {
    if (!refs.current[id]) {
      refs.current[id] = React.createRef();
    }
    return refs.current[id];
  };

  const fetchFavorite = async () => {
    try {
      // setLoading(true)
      const res = await getFavoriteList(JSON.parse(localStorage.getItem('userInfo')).si);
      const favoriteData = res.data.reduce((acc, item) => {
        acc[item.Id_Kala] = {
          isFavorit: true,      // تعداد محصول در سبد خرید
          favoriteId: item.Si // شناسه سبد خرید برای حذف یا ویرایش
        };
        return acc;
      }, {});
      setFavoritList(favoriteData);
      return favoriteData;
    } catch (error) {
      console.error('Error fetching basket:', error);
      return {};
    } finally {
      // setLoading(false)
    }
  };

  const fetchProduct = async (categoryId, basketData, favoriteData) => {
    console.log('..', categoryId)
    setLoading(true);
    try {
      const requestPayload = {
        // pageSize: rows,
        // pageIndex: newPage,
        productGroupId: categoryId || 0, // Use categoryId from URL or fallback
      };
      let res = null
      if (categoryId && categoryId.length > 0 && categoryId != '') {
        res = await GetProductByCategory(requestPayload);

      } else {
        setCategoryChecked('')
        res = await GetProducts();
      }

      const updatedProducts = res.data.map(product => ({
        ...product,
        count: basketData[product.Si]?.count || 0,
        BasketId: basketData[product.Si]?.basketId || '',
        favoriteId: favoriteData[product.Si]?.favoriteId || '',
        isFavorit: favoriteData[product.Si]?.isFavorit || false,
      }));
      setProducts(updatedProducts);

    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };



  const fetchDiscountProduct = async (id) => {
    try {
      setShow(false); // مخفی کردن اولیه
      setSelectedDiscount(null); // پاک کردن مقدار قبلی برای جلوگیری از کش شدن

      const res = await getDiscountProduct(id);
      if (res.data.length > 0) {
        setTimeout(() => {
          setSelectedDiscount({ id, discounts: res.data });
          setShow(true); // نمایش تخفیف جدید
        }, 100); // تاخیر کوتاه برای اطمینان از به‌روز شدن مقدار
      } else {
        setSelectedDiscount(null);
        setShow(false);
      }
    } catch (error) {
      console.error('Error fetching discount:', error);
    }
  };



  useEffect(() => {
  }, [selectedDiscount])




  // Update selected category and fetch its products
  const handleCategoryChange = (item, isInitial = false) => {
    // تبدیل item.Si به int برای همسان‌سازی با categoryChecked
    if (item.id == '') {
      setCategoryChecked('')
      fetchProduct([], basketList, favoritList);  // درخواست محصولات جدید با دسته‌های انتخاب شده

    } else {
      const itemId = parseInt(item.Si, 10);
      console.log(itemId, categoryChecked)
      let updatedCategoryChecked;

      // اگر itemId در categoryChecked موجود بود، حذفش می‌کنیم
      if (categoryChecked.includes(itemId)) {
        updatedCategoryChecked = categoryChecked.filter(id => id !== itemId);
      } else {
        updatedCategoryChecked = [...categoryChecked, itemId];
      }

      setCategoryChecked(updatedCategoryChecked);  // به روز رسانی state
      fetchProduct(updatedCategoryChecked, basketList, favoritList);  // درخواست محصولات جدید با دسته‌های انتخاب شده
    }

    setProducts([]); // Reset products after category change
  };

  // const onPageChange = (event) => {
  //   setFirst(event.first);
  //   setRows(event.rows);
  //   const newPage = Math.floor(event.first / event.rows) + 1;
  //   fetchProduct(categoryChecked || categoryId, newPage);
  // };
  const fetchSearchProducts = async (title) => {
    try {

      const res = await GetProductsbBySearch(title);

      // localStorage.setItem('categoriesList', JSON.stringify(items))
      setProducts(res.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };
  const fetchCategories = async () => {
    try {
      setCategoryLoading(true)
      const pay = { pageSize: 0, pageIndex: 0 };
      const res = await GetListGroupKala(pay);
      if (res.status == 200) {
        setCategoryLoading(false)
        setCategoryList(res.data);
      }

      // localStorage.setItem('categoriesList', JSON.stringify(items))
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setCategoryLoading(false)
    }
  };
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const urlCategoryId = queryParams.get("categoryId");
    const urltitle = queryParams.get("title");


    const categoryId = urlCategoryId || propCategoryId || null;
    setTimeout(() => {

      fetchCategories();
    }, 1500);
    setCategoryId(categoryId);
    // Use URL categoryId to check the box initially
    setCategoryChecked(urlCategoryId ? [parseInt(urlCategoryId, 10)] : []);
    if (urltitle && urltitle != '') {
      fetchSearchProducts(urltitle)
    } else {
      const fetchData = async () => {
        const basketData = await fetchBasketList();
        const favoriteData = await fetchFavorite()
        fetchProduct(urlCategoryId || categoryId, basketData, favoriteData);
      };
      fetchData();
    }

  }, [location.search, propCategoryId]);









  const [visible, setVisible] = useState(false); // Dialog visibility state
  const [dialogContent, setDialogContent] = useState({}); // Dialog content state



  const fetchBasketList = async () => {
    try {
      const res = await getBasketList(JSON.parse(localStorage.getItem('userInfo')).si);
      const basketData = res.data.reduce((acc, item) => {
        acc[item.Id_Kala] = {
          count: item.Nq,      // تعداد محصول در سبد خرید
          basketId: item.Si // شناسه سبد خرید برای حذف یا ویرایش
        };
        return acc;
      }, {});
      setBasketList(basketData);
      return basketData;
    } catch (error) {
      console.error('Error fetching basket:', error);
      return {};
    }
  };


  const handleAddToBasket = async (product, event) => {
    if (!JSON.parse(localStorage.getItem('userInfo'))) {
      window.location.hash = 'login';
      return;
    }
    setSelectedDiscount([])
    await fetchDiscountProduct(product.Si);
    const newCount = product.MinOrder;
    setProducts(products.map(p =>
      p.Si === product.Si ? { ...p, count: newCount } : p
    ));
    setDialogContent(prev => ({ ...prev, count: newCount }));
    try {
      let res = await addBasket({
        id: product.Si,
        count: newCount,
        userId: JSON.parse(localStorage.getItem('userInfo')).si
      });
      if (res.status == 200) {
        showSuccess(`${product.KalaName} به سبد خرید اضافه شد.`)

        addToCart();

        let basketData = await fetchBasketList()
        setProducts(products.map(p =>
          p.Si === product.Si ? { ...p, BasketId: basketData[product.Si]?.basketId, count: newCount } : p
        ));
        setDialogContent(prev => ({ ...prev, BasketId: basketData[product.Si]?.basketId }));

        setBasketList(prev => ({
          ...prev,
          [product.Si]: newCount
        }));
      }


    } catch (error) {
      console.error('Error adding to basket:', error);
    }
  };

  const handleIncrease = async (product, event) => {
    const newCount = product.count + 1;
    setInputValues((prevValues) => ({
      ...prevValues,
      [product.Si]: newCount,
    }));

    try {
      await addBasket({
        id: product.Si,
        count: newCount,
        userId: JSON.parse(localStorage.getItem('userInfo')).si
      });

      setProducts(products.map(p =>
        p.Si === product.Si ? { ...p, count: newCount } : p
      ));
    } catch (error) {
      console.error('Error increasing product count:', error);
    }
  };

  const handleDecrease = async (product, event) => {
    console.log(product)
    const newCount = product.count - 1;


    try {
      if (newCount >= product.MinOrder) {
        await addBasket({
          id: product.Si,
          count: newCount,
          userId: JSON.parse(localStorage.getItem('userInfo')).si
        });
        setInputValues((prevValues) => ({
          ...prevValues,
          [product.Si]: newCount,
        }));

        setProducts(products.map(p =>
          p.Si === product.Si ? { ...p, count: newCount } : p
        ));
      } else {
        await deleteBasket({
          userId: JSON.parse(localStorage.getItem('userInfo')).si,
          id: product.BasketId
        });
        setProducts(products.map(p =>
          p.Si === product.Si ? { ...p, count: 0 } : p
        ));
        addToCart();

      }


    } catch (error) {
      console.error('Error decreasing product count:', error);
    }
  };
  const openDialog = async (product) => {
    const updatedProduct = products.find(p => p.Si === product.Si);
    setDialogContent(updatedProduct || product);
    await fetchDiscountProduct(product.Si)
    setVisible(true);
  };
  useEffect(() => {
    if (selectedDiscount && dialogContent.count) {
      checkDiscount(dialogContent.count);
    }
  }, [selectedDiscount, dialogContent.count]);
  useEffect(() => {

  }, [selectedDiscount])
  const handleDialogIncrease = async () => {
    const newCount = dialogContent.count + 1;


    try {
      setLoadingQuantities(true)
      let res = await addBasket({
        id: dialogContent.Si,
        count: newCount,
        userId: JSON.parse(localStorage.getItem('userInfo')).si
      });
      if (res.status == 200) {
        setInputValues((prevValues) => ({
          ...prevValues,
          [dialogContent.Si]: newCount,
        }));
        setDialogContent(prev => ({ ...prev, count: newCount }));
        setProducts(products.map(p => p.Si === dialogContent.Si ? { ...p, count: newCount } : p));
        setTimeout(() => {
          setLoadingQuantities(false)
          showSuccess(`${parseInt(newCount)} عدد ${dialogContent.KalaName} در سبد خرید شما وجود دارد.`)

        }, 1000);
      }

      // setDialogContent(prev => ({ ...prev, count: newCount }));

      // setProducts(products.map(p =>
      //   p.Si === dialogContent.Si ? { ...p, count: newCount } : p
      // ));
    } catch (error) {
      console.error('Error increasing product count in dialog:', error);
    }
  };

  const handleDialogDecrease = async () => {
    const newCount = dialogContent.count - 1;

    // همگام‌سازی مقدار در دیالوگ و لیست محصولات
    setDialogContent(prev => ({ ...prev, count: newCount }));

    try {
      setLoadingQuantities(true)
      if (newCount >= dialogContent.MinOrder) {
        let res = await addBasket({
          id: dialogContent.Si,
          count: newCount,
          userId: JSON.parse(localStorage.getItem('userInfo')).si
        });
        if (res.status == 200) {
          setInputValues((prevValues) => ({
            ...prevValues,
            [dialogContent.Si]: newCount,
          }));

          setDialogContent(prev => ({ ...prev, count: newCount }));

          setProducts(products.map(p =>
            p.Si === dialogContent.Si ? { ...p, count: newCount } : p
          ));
          setTimeout(() => {
            setLoadingQuantities(false)
            showSuccess(`${parseInt(newCount)} عدد ${dialogContent.KalaName} در سبد خرید شما وجود دارد.`)

          }, 1000);
        }
      } else {
        let res = await deleteBasket({
          userId: JSON.parse(localStorage.getItem('userInfo')).si,
          id: dialogContent.BasketId
        });
        if (res.status == 200) {
          addToCart();
          showSuccess(`کالا از سبد خرید حذف شد.`)
          setDialogContent(prev => ({ ...prev, count: newCount }));

          setProducts(products.map(p =>
            p.Si === dialogContent.Si ? { ...p, count: 0 } : p
          ));
          setTimeout(() => {
            setLoadingQuantities(false)
          }, 1000);
        }

      }
    } catch (error) {
      console.error('Error decreasing product count in dialog:', error);
    }
  };



  const handleDialogClose = () => {
    setVisible(false);
    setDialogContent({});
  };


  const handleDialogInputChange = (value) => {
    const newCount = parseInt(value) || 0;
    if (newCount >= dialogContent.MinOrder) {
      setDialogContent(prev => ({ ...prev, count: newCount }));
    }
  };





  const changeFavorit = async (product) => {
    console.log(product)
    if (!JSON.parse(localStorage.getItem('userInfo'))) {
      window.location.hash = 'login';
      return;
    }
    if (!product.isFavorit) {
      let pay = {
        userId: JSON.parse(localStorage.getItem('userInfo')).si,
        productId: product.Si
      }
      await getAddToFavorite(pay)
      setProducts(products.map(p =>
        p.Si === product.Si ? { ...p, isFavorit: true } : p
      ));
    } else {
      let pay = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).si,
        productId: product.Si
      }
      await deleteFavorite(pay)
      setProducts(products.map(p =>
        p.Si === product.Si ? { ...p, isFavorit: false } : p
      ));
    }
  }
  const changeFavoritDialog = async (product) => {
    console.log(product)
    if (!JSON.parse(localStorage.getItem('userInfo'))) {
      window.location.hash = 'login';
      return;
    }
    if (!product.isFavorit) {
      let pay = {
        userId: JSON.parse(localStorage.getItem('userInfo')).si,
        productId: product.Si
      }
      await getAddToFavorite(pay)
      setDialogContent(prevContent => ({
        ...prevContent,
        isFavorit: true

      }));
      setProducts(products.map(p =>
        p.Si === product.Si ? { ...p, isFavorit: true } : p
      ));
    } else {
      let pay = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).si,
        productId: product.Si
      }
      await deleteFavorite(pay)
      setDialogContent(prevContent => ({
        ...prevContent,
        isFavorit: false

      }));
      setProducts(products.map(p =>
        p.Si === product.Si ? { ...p, isFavorit: false } : p
      ));
    }
  }


  const [inputValues, setInputValues] = useState({});


  // Disable/Enable scroll when dialog is opened/closed
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [visible]);
  const getTotalPrice = (price, product) => {
    let totalPrice = parseInt(product.count) * parseInt(price)
    return totalPrice.toLocaleString()
  }
  useEffect(() => {

  }, [products])


  const checkDiscount = (count) => {
    console.log(dialogContent)
    if (selectedDiscount?.discounts.length > 0) {


      for (const item of selectedDiscount?.discounts) {
        console.log(selectedDiscount, item.Price, count)
        const nq = item.Nq;
        if (nq) {
          if (nq.includes("از") && nq.includes("تا")) {
            // بازه بین دو عدد
            const match = nq.match(/از\s*(\d+)\s*تا\s*(\d+)/);
            if (match) {
              const from = parseInt(match[1]);
              const to = parseInt(match[2]);

              console.log(from, to)
              if (count >= from && count <= to) {
                console.log(selectedDiscount, item.Price, count)
                // setDialogContent(prev => ({ ...prev, Price: item.Price }));
                setDialogContent(prev => ({ ...prev, discountPrice: item.Price }));
                break;
              }
            }
          } else if (nq.includes("بیشتراز")) {
            const match = nq.match(/بیشتراز\s*(\d+)/);
            if (match) {
              const from = parseInt(match[1]);
              if (count > from) {
                setDialogContent(prev => ({ ...prev, discountPrice: item.Price }));
                break;
              }
            }
          }
        }

      }


    }
  }
  useEffect(() => {
    console.log('........', dialogContent)
  }, [dialogContent])
  const handleUpdateBasket = async (newCount, product) => {
    if (!JSON.parse(localStorage.getItem('userInfo')).si) {
      window.location.hash = 'login'; // هدایت به صفحه لاگین
      return;
    }
    try {
      setLoadingQuantities(true)
      if (newCount >= product.MinOrder) {
        let res = await addBasket({ id: product.Si, count: newCount, userId: JSON.parse(localStorage.getItem('userInfo')).si });
        if (res.status == 200) {
          showSuccess(`${parseInt(newCount)} عدد ${dialogContent.KalaName} در سبد خرید شما وجود دارد.`)

          setTimeout(() => {
            setLoadingQuantities(false)
            checkDiscount(newCount)
          }, 2000);
          setProducts(products.map(p =>
            p.Si === product.Si ? { ...p, count: newCount } : p
          ));

          setDialogContent(prev => ({ ...prev, count: newCount }));
        }

      } else {
        let res = await deleteBasket({
          userId: JSON.parse(localStorage.getItem('userInfo')).si,
          id: product.BasketId
        });
        if (res.status == 200) {
          setLoadingQuantities(false)
          setProducts(products.map(p =>
            p.Si === product.Si ? { ...p, count: 0 } : p
          ));
          setDialogContent(prev => ({ ...prev, count: 0 }));
        }

      }
    } catch (error) {
      console.error('Error updating basket:', error);
    }
  };



  const typingTimers = useRef({});
  const findProductBySi = (si) => {
    return products.find((p) => p.Si.toString() === si.toString());
  };

  const handleInputChange = (product, value) => {
    const si = product.Si.toString();
    const numericValue = value.replace(/\D/g, '');

    setInputValues(prev => ({
      ...prev,
      [si]: numericValue,
    }));

    // اگر تایمر قبلی وجود داره، حذف کن
    if (typingTimers.current[si]) {
      clearTimeout(typingTimers.current[si]);
    }

    // شروع تایمر جدید
    typingTimers.current[si] = setTimeout(() => {
      const productObj = findProductBySi(si);
      const parsed = parseInt(numericValue, 10);
      const finalCount = isNaN(parsed) || parsed < productObj.MinOrder ? productObj.MinOrder : parsed;

      setInputValues(prev => ({
        ...prev,
        [si]: finalCount.toString(),
      }));

      handleUpdateBasket(finalCount, productObj);

      // حذف تایمر پس از پایان
      delete typingTimers.current[si];
    }, 1200); // 1.2 ثانیه تأخیر
  };

  function convertToPersianNumbers(input) {
    if (input) {

      const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
      return input.replace(/\d/g, (digit) => persianDigits[digit]);
    }
  }

  const randomWidths = useMemo(() => {
    return Array.from({ length: 10 }, () => Math.floor(Math.random() * 30) + 60);
  }, []);
  return (
    <div>

      {/* {loading && <Loader isLoading={loading} />} */}
      <section className='' style={{ position: 'relative' }}>
        <div className='tab-home mt-5 container product-page'>

          <div className="row">
            <Col md={4} lg={3} sm={12} style={{ paddingRight: '0' }}>
              <div className="filter p-[5px]">
                <div className="rounded-lg p-3" style={{ boxShadow: 'rgba(0, 0, 0, 0.15) 0px 2px 8px' }}>
                  {/* <div className="flex items-center gap-2">
                    <img src={Filter} alt="" className='w-7' />
                    <h5 className='text-green font-bold mt-1'>فیلتر ها</h5>
                  </div> */}
                  <div className="">
                    <div className="flex items-center gap-2">
                      <img src={Filter} alt="" className='w-7' />
                      <h5 className='text-green font-bold mt-1'>دسته بندی ها</h5>
                    </div>
                    {categoryList.length > 0 ? (
                      <div className="mt-4">
                        {/* Add "All Products" checkbox */}
                        <Form.Check
                          onChange={() => handleCategoryChange({ id: "" })} // Handle "All Products"
                          type='checkbox'
                          label="همه محصولات"
                          id="all-products"
                          checked={categoryChecked === ""}
                        />
                        {categoryList.length && categoryList.map((item) => (
                          <Form.Check
                            key={item.Si}
                            onChange={() => handleCategoryChange(item)}
                            type='checkbox'
                            label={item.GrpName}
                            id={item.Si}
                            checked={categoryChecked.includes(parseInt(item.Si, 10))}

                          />
                        ))}
                      </div>
                    ) : (<div className="skeleton-wrapper mt-5">
                      {randomWidths.map((width, index) => (
                        <div className='d-flex align-items-center gap-2' key={index}>
                          <Form.Check type='checkbox' disabled />
                          <Skeleton className='mt-2' width={`${width}%`} />
                        </div>
                      ))}
                    </div>)}

                  </div>
                </div>
              </div>
              <div className='mobile-filter d-flex gap-2  mb-3'>
                <div className='item ' >
                  <img src={FilterMobile} alt="" />
                </div>
                {/* <div >
                  <button className='btn btn-outline-primary text-xs p-2 ' style={{ textWrap: 'nowrap' }} >بسته بندی</button>
                </div>
                <div >
                  <button className='btn btn-outline-primary text-xs p-2' style={{ textWrap: 'nowrap' }} onClick={() => setVisibleFilter(true)}>حجم محصول</button>
                </div> */}
                <div >
                  <button className='btn btn-outline-primary text-xs p-2' style={{ textWrap: 'nowrap' }} onClick={(e) => setVisibleCategory(true)}>دسته بندی ها</button>
                </div>
                <Sidebar header="دسته بندی ها" visible={visibleCategory} position="bottom" onHide={() => setVisibleCategory(false)}>
                  <Form className='filter-category px-2'>
                    {/* Add "All Products" checkbox here as well */}
                    <Form.Check
                      onChange={() => handleCategoryChange({ id: "" })}
                      type='checkbox'
                      label="همه محصولات"
                      id="all-products-sidebar"
                      checked={categoryChecked == ''}
                    />
                    {categoryList.length && categoryList.map((item) => (
                      <Form.Check
                        key={item.Si}
                        onChange={() => handleCategoryChange(item)}
                        type='checkbox'
                        label={item.GrpName}
                        id={item.Si}
                        checked={categoryChecked.includes(parseInt(item.Si, 10))}
                      />
                    ))}
                  </Form>
                  <div style={{ position: 'absolute', bottom: '1em', left: '0', zIndex: '1000' }} className='px-3 gap-2 w-100 d-flex align-items-center justify-content-between'>
                    <button className='btn btn-primary flex-1' onClick={(e) => setVisibleCategory(false)}>مشاهده</button>
                    <button className='btn btn-outline-primary flex-1' onClick={(e) => setCategoryChecked('')}>حذف فیلتر</button>
                  </div>
                </Sidebar>
                <Sidebar header="حجم محصول" visible={visibleFilter} position="bottom" onHide={() => setVisibleFilter(false)}>
                  <Form className='filter-category px-2'>
                    <Form.Group className="mt-3">
                      <Form.Label className='text-sm'>حجم محصول</Form.Label>
                      <Form.Select aria-label="">
                        <option>200cc</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Form.Group>
                  </Form>
                  <div style={{ position: 'absolute', bottom: '1em', left: '0', zIndex: '1000' }} className='px-3 gap-2 w-100 d-flex align-items-center justify-content-between'>
                    <button className='btn btn-primary flex-1' onClick={(e) => setVisibleCategory(false)}>مشاهده</button>
                    <button className='btn btn-outline-primary flex-1' onClick={(e) => setCategoryChecked('')}>حذف فیلتر</button>
                  </div>
                </Sidebar>
              </div>
            </Col>

            <Col md={8} lg={9} sm={12} style={{ paddingLeft: '0' }}>
              <div className="row gy-2 gx-2">
                {loading ? (
                  <div className="skeleton-wrapper row gy-2 gx-2">
                    {[...Array(10)].map((_, index) => (
                      <div className=' col-12 col-lg-3 col-md-6'>

                        <div className='product-item'>

                          <div className='product-img aspect-[4/4]'>
                            <Skeleton height='100%' className='img-box img-product' />
                          </div>
                          <div className='flex-1'>
                            <div className='detail flex-1 w-100'>
                              <Skeleton className='product-title' />
                              <Skeleton className='mt-2 number-font' />
                            </div>

                            <div >
                              <Skeleton height='40px' className='mt-3 btn btn-primary w-100 h-[48px]' />
                              {/* )} */}
                            </div>

                            <Skeleton className='f-10 mt-2' />
                          </div>

                        </div>
                      </div>

                    ))}
                  </div>
                ) : (
                  <>  {products.map((product, index) => (
                    <div className=' col-12 col-lg-3 col-md-6' style={{ animationDelay: `${index * 0.1}s` }} key={product.id}>

                      <div className='product-item'
                        key={product.Si}  >

                        <div className='product-img aspect-[4/4]'>
                          <img
                            onClick={() => navigate(`/product?id=${product.Code}`)}
                            src={product.Pic_A}
                            onError={(e) => { e.target.src = DefaultImg }}
                            className='img-box img-product'
                            alt={product.KalaName}
                          />                          <img src={product.isFavorit ? HeartBold : Hearth} className='favorite-icon' alt="" onClick={(e) => { e.stopPropagation(); changeFavorit(product) }} />
                        </div>
                        <div>
                          <div className='detail' onClick={() => navigate(`/product?id=${product.Code}`)}>
                            <h4 className='mt-4'>{convertToPersianNumbers(product.KalaName)}</h4>
                            <h5 className='mt-2 number-font'>{parseInt(product.Price).toLocaleString()} تومان</h5>
                          </div>

                          <div >
                            {/* {product.count >= product.MinOrder ? (
                            <>
                              <div className='d-flex align-items-center justify-content-center mt-3 gap-2 increas'>
                                <button className='btn btn-primary w-[48px]' onClick={(e) => { e.stopPropagation(); handleIncrease(product) }}>+</button>
                                <input
                                  className='form-control w-[48px] h-[48px] text-center number-font'
                                  style={{ height: '48px' }}
                                  value={inputValues[product.Si] ? inputValues[product.Si] : product.count}
                                  onChange={(e) => handleInputChange(product, e.target.value)}
                                  onBlur={() => handleBlur(product)}
                                />
                                <button className='btn btn-primary w-[48px] d-flex align-items-center justify-center ' onClick={(e) => { e.stopPropagation(); handleDecrease(product) }}>
                                  {product.count === product.MinOrder ? <img src={Trash} /> : '-'}
                                </button>
                              </div>

                              {selectedDiscount?.id === product.Si && selectedDiscount?.discounts.length > 0 && (
                                <Overlay target={getRef(product.Si).current} show={show && selectedDiscount?.id === product.Si} placement="bottom">
                                  {(props) => (
                                    <Tooltip id="overlay-example" {...props}>
                                      <div className="discount-list">
                                        {selectedDiscount.discounts.map((discount, index) => (
                                          <div key={index} className="discount-item">
                                            <span className='number-font'>{discount.Nq ? discount.Nq : ''}</span>
                                            <span className='number-font'>{discount.Price ? discount.Price.toLocaleString() : ''} تومان</span>
                                          </div>
                                        ))}
                                      </div>
                                    </Tooltip>
                                  )}
                                </Overlay>
                              )}


                            </>
                          ) : ( */}
                            <button className='mt-3 btn btn-primary w-100' onClick={() => openDialog(product)}>افزودن</button>
                            {/* )} */}
                          </div>

                          <span className='f-10'>حداقل تعداد خرید محصول {convertToPersianNumbers((product.MinOrder)?.toString())} عدد</span>
                        </div>

                      </div>
                    </div>
                  ))}
                  </>
                )}

                {/* <Paginator className='mt-5 px-0' pageLinkSize={3} first={first} rows={rows} totalRecords={total} onPageChange={onPageChange} /> */}
              </div>
            </Col>
          </div>
        </div>
      </section>
      <Dialog
        draggable={false}
        dismissableMask
        visible={visible}
        style={{ width: '35vw' }}
        breakpoints={{ '1800px': '25vw', '1600px': '35vw','1300px': '50vw', '1100px': '50vw', '900px': '60vw', '600px': '400vw', '500px': '95vw' }}
        onHide={handleDialogClose}
        className="custom-dialog "
      >
        <div className='product-item'>
          <div className='d-flex justify-content-start gap-4 mobile-direction'>
            <div className='product-img mx-0 aspect-[4/4]'>
              <img src={dialogContent.Pic_A} className='img-box img-product' alt={dialogContent.KalaName} />
              <img src={dialogContent.isFavorit ? HeartBold : Hearth} className='favorite-icon' alt="" onClick={(e) => { e.stopPropagation(); changeFavoritDialog(dialogContent) }} />
            </div>
            <div>
              <div className='detail text-center d-flex align-items-center gap-3 justify-content-between'>
                <div className='flex-1 text-right text-mobile-center'>
                  <h4 className='mt-4'>{convertToPersianNumbers(dialogContent.KalaName)}</h4>
                  <span className='text-sm'>توضیحات محصول: {dialogContent.Tp}</span>
                  <div className='d-flex align-items-center justify-content-start text-mobile-center gap-3 mt-2'>
                    <span className='text-[12px] item' >کد کالا: {convertToPersianNumbers(dialogContent.Code)}</span>
                    <span className='text-[12px] item' >گروه کالا: {dialogContent.GrpName}</span>
                  </div>
                  <div className='d-flex align-items-center gap-5 justify-content-start text-mobile-center'>
                    <h5 className={`${(dialogContent.discountPrice && dialogContent.discountPrice != dialogContent.Price) ? 'discount-price' : ''} mt-2 number-font`}>{parseInt(dialogContent.Price).toLocaleString()} تومان</h5>
                    {(dialogContent.discountPrice && dialogContent.discountPrice != dialogContent.Price) && (

                      <h5 className='mt-2 number-font'>{parseInt(dialogContent.discountPrice).toLocaleString()} تومان</h5>
                    )}
                  </div>

                  <span className='text-[12px] item'>حداقل تعداد خرید محصول {convertToPersianNumbers((dialogContent.MinOrder)?.toString())} عدد</span>
                </div>



              </div>
            </div>
          </div>
          {selectedDiscount?.id === dialogContent.Si && selectedDiscount?.discounts.length > 0 && (
            <div className="discount-list  flex-1 mt-4">
              {/* <h4 className='mt-4 text-lg text-right'>تخفیفات</h4> */}

              {selectedDiscount.discounts.map((discount, index) => (
                <div key={index} className="discount-item p-2">
                  <span className="number-font">{discount.Nq ?? ''}</span>
                  <span className="number-font">{discount.Price?.toLocaleString() ?? ''} تومان</span>
                </div>
              ))}
            </div>
          )}

          {dialogContent.count >= dialogContent.MinOrder ? (
            <div>
              <div className='text-center w-100 d-flex justify-content-end'>
                <div className='d-flex align-items-center justify-content-center mt-4 gap-2 increas w-fit' ref={getRef(dialogContent.Si)}>
                  <button className='btn btn-primary w-[48px]' onClick={handleDialogIncrease}>+</button>
                  {loadingQuantities ? (
                    <div className='form-control w-[48px] h-[48px] text-center three-loader d-flex align-items-center justify-content-center' style={{ width: '48px', height: '48px' }}>
                      <ThreeLoader />

                    </div>
                  ) : (
                    <input
                      className={`form-control w-[48px] h-[48px] text-center number-font ${loadingQuantities ? 'loading-dots' : ''}`}
                      style={{ height: '48px' }}
                      value={inputValues[dialogContent.Si] ?? dialogContent.count}
                      onChange={(e) => handleInputChange(dialogContent, e.target.value)}
                    // onMouseEnter={async () => {
                    //   setSelectedDiscount(null)
                    //   await fetchDiscountProduct(dialogContent.Si)
                    // }}
                    />
                  )}



                  <button className='btn btn-primary w-[48px] d-flex align-items-center justify-center' onClick={handleDialogDecrease}>
                    {dialogContent.count === dialogContent.MinOrder ? <img src={Trash} /> : '-'}
                  </button>
                </div>
              </div>

              {/* {selectedDiscount?.id === dialogContent.Si && selectedDiscount?.discounts.length > 0 && (
                <div ref={ref}>
                  <Overlay
                    target={getRef(dialogContent.Si).current}
                    show={show && selectedDiscount?.id === dialogContent.Si}
                    placement="left"
                  >
                    {(props) => (
                      <Tooltip id="overlay-example" {...props}>
                        <div className="discount-list">
                          {selectedDiscount.discounts.map((discount, index) => (
                            <div key={index} className="discount-item">
                              <span className="number-font">{discount.Nq ?? ''}</span>
                              <span className="number-font">{discount.Price?.toLocaleString() ?? ''} تومان</span>
                            </div>
                          ))}
                        </div>
                      </Tooltip>
                    )}
                  </Overlay>
                </div>

              )} */}
              <hr />
              <div className='d-flex align-items-center justify-content-between'>
                <div>
                  <h6 className='text-sm number-font d-flex' style={{ flexWrap: 'wrap' }}>مجموع ({inputValues[dialogContent.Si] ? inputValues[dialogContent.Si] : dialogContent.count} کالا) : <span className='text-[#00a14b] font-bold number-font'>{getTotalPrice(dialogContent.Price, dialogContent)} تومان</span></h6>
                </div>
                <button className='btn btn-outline-primary py-1 h-[40px]' style={{ fontSize: '12px', height: '40px', textWrap: 'nowrap' }} onClick={() => { window.location.href = '/orders' }}>مشاهده سبد خرید</button>
              </div>
            </div>

          ) : (
            <button className='mt-3 btn btn-primary w-100' onClick={(e) => handleAddToBasket(dialogContent, e)}>افزودن</button>
          )}
        </div>
      </Dialog>


    </div>
  );
}

export default Products;
